<script>
    export default {
        name: "ProductSizeList",
        props: {
            sizesList: Array,
            productId: Number,
        },
        methods: {
            selectSize(id) {
                this.$emit("select-size", id);
            },
        },
    };
</script>

<template>
    <div class="c-size-list">
        <router-link
            :to="{ name: 'Product', params: { slug: size.productSlug } }"
            class="c-size-list__item"
            :class="{ 'c-size-list__item--active': size.productId === productId }"
            v-for="size in sizesList"
            :key="size.productId"
            :tabindex="size.productId === productId ? -1 : 0"
        >
            {{ size.name }}
        </router-link>
    </div>
</template>

<style lang="scss">
    .c-size-list {
        display: flex;
    }

    .c-size-list__item {
        position: relative;
        margin-right: 4px;
        padding: var(--product-size-padding);
        color: var(--primary-text);
        font-size: 14px;
        line-height: 14px;
        border: var(--product-size-border);
        border-radius: var(--product-size-border-radius);
        cursor: pointer;
        transition: 0.3s ease all;
        &:hover,
        &:focus {
            border-color: var(--product-size--hover-border);
            box-shadow: var(--product-size--hover-shadow);
            outline: none;
        }
    }

    //
    // --mod
    //

    .c-size-list__item--active {
        color: var(--product-size--active-color);
        border-color: var(--product-size--active-color);
        box-shadow: var(--product-size--active-shadow);
        pointer-events: none;
    }
</style>
